const styles = (theme) => ({
    root: {
        flexGrow: 1,
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
    },
    main: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(6),
    },
    profileCard: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3),
        alignItems: 'center',
        borderRadius: theme.shape.borderRadius,
        [theme.breakpoints.up('md')]: {
            position: 'sticky',
            top: theme.spacing(4),
        },
    },
    profileHeader: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(1),
        textAlign: 'center',
    },
    avatar: {
        color: theme.palette.getContrastText(theme.palette.primary.main),
        backgroundColor: theme.palette.primary.main,
        height: 128,
        width: 128,
        fontSize: '3.25rem',
        [theme.breakpoints.down('sm')]: {
            height: 96,
            width: 96,
            fontSize: '2.5rem',
        },
    },
    profileName: {
        fontWeight: 700,
        wordBreak: 'break-word',
    },
    username: {
        color: theme.palette.text.secondary,
        wordBreak: 'break-word',
    },
    profileFields: {
        alignSelf: 'stretch',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
    },
    profileField: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.35),
    },
    profileLabel: {
        fontSize: '0.75rem',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.6px',
        color: theme.palette.text.secondary,
    },
    profileValue: {
        wordBreak: 'break-word',
    },
    projectChipGroup: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(0.75),
    },
    projectSearch: {
        width: '100%',
    },
    solutionsColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3),
    },
    controlCard: {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(2.5),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    controlRow: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    resetButton: {
        alignSelf: 'flex-start',
    },
    projectSection: {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(2.5),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    projectHeading: {
        fontWeight: 600,
        wordBreak: 'break-word',
    },
    solutionsGrid: {
        marginTop: theme.spacing(0.5),
    },
    emptyState: {
        padding: theme.spacing(4),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        border: `1px dashed ${theme.palette.divider}`,
    },
});

export default styles;
